import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'profile-confirm',
	template: require('./profile-confirm.component.html'),
})
export class ProfileConfirmComponent implements OnInit {
	@Input() isGroupUserIdsBigModalEnabled: boolean = false;
	public text: string = 'Συμπληρώστε το OTP';

	ngOnInit(): void {
		if (this.isGroupUserIdsBigModalEnabled) {
			this.text = 'Εισάγετε το OTP που λάβατε στο κινητό σας';
		}
	}
}
